import { ArrowUpRight } from 'lucide-react';
import type { ReactNode } from 'react';

import { isValidWebsiteUrl } from './social-format';

const srOnly = {
  position: 'absolute',
  width: 1,
  height: 1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
} as const;

/** A link that opens in a new tab. Only http(s) addresses become links; anything
 *  else (such as a `javascript:` address) is shown as plain text. */
export function ExternalLink({
  href,
  children,
  mono,
}: {
  href: string;
  children: ReactNode;
  mono?: boolean;
}) {
  if (!isValidWebsiteUrl(href)) {
    return <span className={mono ? 'nb-mono' : undefined}>{children}</span>;
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={mono ? 'nb-mono' : undefined}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        color: 'var(--nb-primary)',
        fontSize: 12.5,
        fontWeight: 600,
        minWidth: 0,
        textDecoration: 'none',
      }}
    >
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {children}
      </span>
      <ArrowUpRight size={11} aria-hidden="true" style={{ flex: '0 0 auto' }} />
      <span style={srOnly}>(opens in a new tab)</span>
    </a>
  );
}
